module.exports = __webpack_public_path__ + "static/media/logo-icon.4d7b6b85.png";